import { Component, QueryList, ContentChildren, AfterContentInit, Input, Output, EventEmitter, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';

import { Subject } from 'rxjs';
import { filter, tap, takeUntil } from 'rxjs/operators';

import { TabComponent } from './tab/tab.component';

@Component({
    selector: 'aa-tab-group-no-slide',
    templateUrl: './tab-group-no-slide.component.html',
    styleUrls: [
        './tab-group.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabGroupNoSlideComponent implements OnInit, AfterContentInit, OnDestroy
{
    @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
    @Input() justified: boolean = false;
    @Input() height: number = 50;
    @Input() customCls: string = '';
    @Output() selectedTab: EventEmitter<any> = new EventEmitter();
    private destroyator = new Subject();
    private oldTabIndex: number = undefined;
    private newTabIndex: number = 0;
    public height1: number;

    constructor (
        private router: Router,
        private location: Location
    )
    { }

    ngOnInit ()
    {
        this.height1 = this.height;
        this.router.events
            .pipe(
                filter((evt) => evt instanceof NavigationEnd),
                tap(() =>
                {
                    const routedTabs: TabComponent[] = this.tabs
                        .filter((tab) => this.router.url === tab.tabRoute);
                    if (routedTabs.length !== 0)
                    {
                        this.activateTab(routedTabs[0]);
                    }
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    ngAfterContentInit ()
    {
        const routedTabs: TabComponent[] = this.tabs
            .filter((tab) => this.router.url === tab.tabRoute);

        this.tabs.forEach((tab, idx) => tab.id = idx);

        if (routedTabs.length !== 0)
        {
            this.activateTab(routedTabs[0]);
        }
        else
        {
            const activeTabs: TabComponent[] = this.tabs
                .filter((tab) => tab.active);

            if (activeTabs.length === 0)
            {
                this.selectTab(this.tabs.first);
            }
        }
    }

    selectTab (tab: TabComponent): void
    {
        // ! TODO Remplacer ce code pourri : !!tab..
        if (!!tab && tab.tabRoute)
        {
            this.location.replaceState(tab.tabRoute);
        }

        this.activateTab(tab);
    }

    private activateTab (tab: TabComponent): void
    {
        this.oldTabIndex = this.newTabIndex;

        this.newTabIndex = tab.id;
        this.selectedTab.emit({ oldTab: this.oldTabIndex, newTab: this.newTabIndex });
        this.tabs.toArray().forEach((t) => t.active = false);
        tab.active = true;
    }
}
